var _circle, _path, _circle2, _circle3, _g, _path2, _ellipse, _g2, _path3, _ellipse2, _g3, _path4, _ellipse3, _g4, _path5, _ellipse4, _g5, _path6, _ellipse5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 623,
    viewBox: "0 0 586 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 292.5,
    r: 292,
    stroke: "#0087FF",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.5 1.10547C247.228 1.10547 201.621 12.1249 160.454 33.2518C119.287 54.3787 83.7426 85.0057 56.7629 122.598C29.7833 160.191 12.1439 203.668 5.30461 249.431C-1.53469 295.195 2.62273 341.93 17.4328 385.768C32.2429 429.605 57.2798 469.286 90.4716 501.526C123.663 533.766 164.056 557.637 208.306 571.166C252.556 584.694 299.392 587.49 344.937 579.322C390.483 571.154 433.428 552.257 470.22 524.195L293.5 292.502V1.10547Z",
    fill: "url(#paint0_linear_1351_27369)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 292.5,
    r: 209.217,
    stroke: "#0087FF",
    strokeOpacity: 0.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 295.813,
    r: 137.472,
    stroke: "#0087FF",
    strokeOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1351_27369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 450,
    r: 20,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.053 447.952C437.053 451.307 432.207 459.311 430.962 459.311C429.716 459.311 424.87 451.307 424.87 447.952C424.87 444.596 427.597 441.876 430.962 441.876C434.326 441.876 437.053 444.596 437.053 447.952Z",
    fill: "#B29DEC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.962,
    cy: 447.69,
    rx: 2.64856,
    ry: 2.64168,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1351_27369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 577,
    r: 24,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.264 574.54C376.264 578.567 370.449 588.171 368.954 588.171C367.459 588.171 361.644 578.567 361.644 574.54C361.644 570.513 364.917 567.249 368.954 567.249C372.991 567.249 376.264 570.513 376.264 574.54Z",
    fill: "#6CB5F5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.954,
    cy: 574.224,
    rx: 3.17827,
    ry: 3.17001,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1351_27369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 440,
    r: 20,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0612 437.047C47.0612 440.797 41.6446 449.743 40.2525 449.743C38.8604 449.743 33.4438 440.797 33.4438 437.047C33.4438 433.296 36.4922 430.256 40.2525 430.256C44.0128 430.256 47.0612 433.296 47.0612 437.047Z",
    fill: "#FF8762"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2528,
    cy: 436.752,
    rx: 2.96029,
    ry: 2.9526,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1351_27369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 472,
    r: 30,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.887 467.572C194.887 473.198 186.762 486.617 184.674 486.617C182.586 486.617 174.461 473.198 174.461 467.572C174.461 461.946 179.033 457.386 184.674 457.386C190.314 457.386 194.887 461.946 194.887 467.572Z",
    fill: "#75CFA9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.673,
    cy: 467.13,
    rx: 4.44044,
    ry: 4.4289,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1351_27369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 447,
    r: 20,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M546.925 444.047C546.925 447.797 541.509 456.743 540.117 456.743C538.725 456.743 533.308 447.797 533.308 444.047C533.308 440.296 536.356 437.256 540.117 437.256C543.877 437.256 546.925 440.296 546.925 444.047Z",
    fill: "#FFD12E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.117,
    cy: 443.751,
    rx: 2.96029,
    ry: 2.9526,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1351_27369",
    x: 391.614,
    y: 413.037,
    width: 78.7723,
    height: 78.7723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.69307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1351_27369",
    x: 325.614,
    y: 536.037,
    width: 86.7723,
    height: 86.7723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.69307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1351_27369",
    x: 0.613852,
    y: 403.037,
    width: 78.7723,
    height: 78.7723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.69307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1351_27369",
    x: 131.861,
    y: 420.878,
    width: 108.278,
    height: 108.278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0174
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0696
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1351_27369",
    x: 501.614,
    y: 410.037,
    width: 78.7723,
    height: 78.7723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.69307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.39316 0 0 0 0 0.487291 0 0 0 0 0.704167 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_27369",
    x1: 293.5,
    y1: 1.10547,
    x2: 486.405,
    y2: 184.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0087FF",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustration);
export default __webpack_public_path__ + "static/media/home-illustration.da08d648eba847da15810e4a73515fa6.svg";
export { ForwardRef as ReactComponent };